/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { Box, xcss } from '@atlaskit/primitives';
import { N40 } from '@atlaskit/theme/colors';
import { scrollableContainerShadowsCssComponents } from '../../../issue-like-table';
var contentContainerStyles = xcss({
  display: 'grid',
  maxHeight: '420px',
  overflow: 'auto',
  borderBottom: "2px solid ".concat("var(--ds-background-accent-gray-subtler, ".concat(N40, ")")),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  backgroundImage: scrollableContainerShadowsCssComponents.backgroundImage,
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  backgroundPosition: scrollableContainerShadowsCssComponents.backgroundPosition,
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  backgroundRepeat: scrollableContainerShadowsCssComponents.backgroundRepeat,
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  backgroundSize: scrollableContainerShadowsCssComponents.backgroundSize,
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  backgroundAttachment: scrollableContainerShadowsCssComponents.backgroundAttachment
});
var tableContainerStyles = xcss({
  borderTopLeftRadius: "var(--ds-border-radius-200, 8px)",
  borderTopRightRadius: "var(--ds-border-radius-200, 8px)",
  border: "1px solid ".concat("var(--ds-border, ".concat(N40, ")"))
});
export var ContentContainer = function ContentContainer(_ref) {
  var children = _ref.children,
    withTableBorder = _ref.withTableBorder;
  return jsx(Box, {
    xcss: [contentContainerStyles, withTableBorder && tableContainerStyles]
  }, children);
};